import React from "react";
import { makeStyles, Divider } from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";
import "./raw_files/styles.css";
export function NavBar({ className }) {
  let location = useLocation();
  let current_path = location.pathname;

  return (
    <>
      <div
        className={`navbar card row  bgi-no-repeat bgi-size-cover ${className}`}
      >
        <ul className="navList">
          <Link
            to="/account/profile"
            className={
              "link" + (current_path === "/account/profile" ? " active" : "")
            }
          >
            <div className="row">
              <i className="fa fa-user-alt"></i>
              <li>حساب کاربری</li>
            </div>
          </Link>

          <Divider orientation="vertical" flexItem />
          <Link
            to="/account/travels"
            className={
              "link" + (current_path === "/account/travels" ? " active" : "")
            }
          >
            <div className="row">
              <i className="fa fa-tasks"></i>
              <li>سفر ها</li>
            </div>
          </Link>

          <Divider orientation="vertical" flexItem />
          <Link
            to="/account/transaction"
            className={
              "link" +
              (current_path === "/account/transaction" ? " active" : "")
            }
          >
            <div className="row">
              <i className="fa fa-coins"></i>
              <li>تراکنش ها</li>
            </div>
          </Link>

          <Divider orientation="vertical" flexItem />
          <Link
            to="/account/recharge"
            className={
              "link" + (current_path === "/account/recharge" ? " active" : "")
            }
          >
            <div className="row">
              <i className="fa fa-credit-card"></i>
              <li>افزایش اعتبار</li>
            </div>
          </Link>

          <Divider orientation="vertical" flexItem />
          <Link
            to="/account/passengers"
            className={
              "link" + (current_path === "/account/passengers" ? " active" : "")
            }
          >
            <div className="row">
              <i className="fa fa-user-friends"></i>
              <li>لیست مسافران</li>
            </div>
          </Link>

          <Divider orientation="vertical" flexItem />
          <Link
            to="/account/reports"
            className={
              "link" + (current_path === "/account/reports" ? " active" : "")
            }
          >
            <div className="row">
              <i classNam="fa fa-window-close"></i>
              <li>گزارشات تخلف</li>
            </div>
          </Link>
          {/*<Divider orientation="vertical" flexItem/>*/}

          {/*<Link to="/account/dashboard" className={"link"+(current_path === "/account/dashboard"?' active':'')}>*/}

          {/*    <div className="row">*/}
          {/*        <i className="fa fa-chart-line"></i>*/}
          {/*        <li>داشبورد</li>*/}
          {/*    </div>*/}
          {/*</Link>*/}
        </ul>
      </div>
    </>
  );
}
